import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=de447238&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=babel&"
export * from "./comments.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de447238",
  null
  
)

export default component.exports